module.exports = __webpack_public_path__ + "img/12_klio_23.1fe49da4.jpg";